export default __webpack_public_path__ + "static/media/pan.8981360e.png";